import dayjs from "dayjs";
import { STATUS_CODE } from "./constDispatch";

// day_start tới danh sách đã được DMY_to_YMD đổi sang "YYYY/MM/DD", nên so sánh
// chuỗi là so sánh ngày. Mọi thứ khác (null, "Invalid Date") coi như không có
// travel date.
const DAY_RE = /^\d{4}\/\d{2}\/\d{2}$/;

const day_key = (x) => (typeof x === "string" && DAY_RE.test(x) ? x : null);

// proceeding ghim lên đầu, cancel dồn xuống cuối, các status còn lại ở giữa và
// giữ nguyên thứ tự tương đối của nhau.
const status_rank = (status) => {
  if (status === STATUS_CODE.proceeding) return 0;
  if (status === STATUS_CODE.cancel) return 2;
  return 1;
};

// 0 = chưa khởi hành (tính cả hôm nay), 1 = đã qua, 2 = không có travel date.
const date_bucket = (day, today) => {
  if (day == null) return 2;
  return day >= today ? 0 : 1;
};

// Ưu tiên proceeding lên đầu và cancel xuống cuối, trong mỗi nhóm thì travel
// date gần hôm nay nhất
// lên trên: sắp khởi hành tăng dần trước, rồi các chuyến đã qua (gần đây trước),
// cuối cùng là booking chưa có travel date.
export function sortBookings(data, today = dayjs().format("YYYY/MM/DD")) {
  if (data == null) return data;

  // Sort tại chỗ sẽ đổi thứ tự của mảng `data` đang nằm trong state, nên copy.
  return [...data].sort((a, b) => {
    const rank = status_rank(a.status) - status_rank(b.status);
    if (rank !== 0) return rank;

    const day_a = day_key(a.day_start);
    const day_b = day_key(b.day_start);
    const bucket_a = date_bucket(day_a, today);
    const bucket_b = date_bucket(day_b, today);
    if (bucket_a !== bucket_b) return bucket_a - bucket_b;

    // Cùng nhóm "không có ngày" thì giữ nguyên thứ tự (Array#sort là stable).
    if (day_a == null || day_b == null) return 0;

    return bucket_a === 0
      ? day_a.localeCompare(day_b)
      : day_b.localeCompare(day_a);
  });
}
